import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
} from "@mui/material";

import { Row, Col, FormGroup, Alert, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { addOrgAccount } from "../../../store/actions";
import spinner from "../../../assets/images/loadingGif.gif";

import { countryList } from "../../../utilities/countries";

import { Modal, Box } from '@mui/material';
import PhoneInput, { isPossiblePhoneNumber  } from 'react-phone-number-input';
import { makeStyles } from '@mui/styles';
import { commonStyles } from '../../../theme';

const availableSubscriptionTypes = [
  "ASSISTED TRIAL",
  "ASSISTED PAID",
  "AWS PAID PUBLIC",
  "AWS PAID PRIVATE",
  "AWS TRIAL",
  "ASSISTED CUSTOM",
];

const useStyles = makeStyles((theme) => ({
  ...commonStyles,
  // Add any component-specific styles here
  customStyle: {
    // Your custom styles
  }
}));

const AddOrganizationAccount = (props) => {
  console.log("AddOrganizationAccount props: ", props)
  const classes = useStyles();
  const { 
    open,
    onClose,
    orgCode,
    resourceGroups
  } = props;

  const [accountNumber, setAccountNumber] = useState("");
  // const [location, setLocation] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("ASSISTED TRIAL");
  const [resourceGroup, setResourceGroup] = useState(resourceGroups[0]?.resourcename);
  
  const handlePhoneChange = (value) => {
    let isInvalidResult;
    if (value===null || value === "" || value === undefined) {
      isInvalidResult = true;
      value="";
    } else {
      isInvalidResult = !isPossiblePhoneNumber(value);
    }
    if (isInvalidResult) {
      setPhonenumber(value);
      setPhoneError("Please enter a valid phone number");
    } else {
      setPhonenumber(value);
      setPhoneError("");
    }
  }

  const handlePhoneBlur = () => {
    let isInvalidResult;
    if (!phonenumber){
      isInvalidResult = true;
    } else {
      isInvalidResult = !isPossiblePhoneNumber(phonenumber);
    }
    if (isInvalidResult) {
      setPhoneError("Please enter a valid phone number");
    } else {
      setPhoneError("");
    }
  }

  const isAddOrgAccountFormInvalid = () => { 
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isInvalidItems = [
      {
        field: "accountNumber",
        isInvalid: !/^[0-9]{12}$/.test(accountNumber), 
      },
      {
        field: "address",
        isInvalid: address === "" ? true : false,
      },
      {
        field: "city",
        isInvalid: city === "" ? true : false,
      },
      {
        field: "state",
        isInvalid: state === "" ? true : false,
      },
      {
        field: "zip",
        isInvalid: zip === "" ? true : false,
      },
      {
        field: "country",
        isInvalid: (country === "" || country ==="Select Country") ? true : false,
      },
      {
        field: "email",
        isInvalid: !emailRegex.test(email),
      },
      {
        field: "phonenumber",
        isInvalid: !isPossiblePhoneNumber(phonenumber),
      },
      {
        field: "subscriptionType",
        isInvalid: !availableSubscriptionTypes.includes(subscriptionType),
      },
    ];
    // console.log("isInvalidItems :", isInvalidItems);

    return isInvalidItems?.filter((item) => item.isInvalid)?.length > 0;
  }

  const handleAddOrgAccount = (e) => {

    const addOrgAccountPayload = {
      orgCode,
      accountNumber,
      location: "us-east-1",
      accounttype: "AWS",
      address,
      city,
      state,
      zip,
      country,
      email,
      phonenumber,
      subscriptionType,
      resourceGroupRequestDTOS: resourceGroup
    };
    console.log("addOrgAccountPayload : ", addOrgAccountPayload);

    props.addOrgAccount(addOrgAccountPayload);
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Box className={classes.modalContent}>
        <h3>Add Organization Account</h3>
        {props.isAddingOrgAccount && (
          <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        {/* Error message */}
        {props.addOrgAccountError && (
          <Alert className="mt-3 mb-0" color="danger">
            Error while adding organization account. {JSON.stringify(props.addOrgAccountError?.message)}
          </Alert>
        )}
        <AvForm>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Row>
              <Col lg="12">
                <FormGroup>
                  <Label for="accountNumber">Account Number</Label>
                  <AvField
                    type="number"
                    name="accountNumber"
                    id="accountNumber"
                    onChange={(e) => setAccountNumber(e.target.value)}
                    value={accountNumber}
                    errorMessage="Enter 12 digits account number"
                    validate={{
                      required: {value: true},
                      pattern: {value: '^[0-9]{12}$'},
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="subscriptionType">Subscription Type</Label>
                  <AvField
                    type="select"
                    name="subscriptionType"
                    id="subscriptionType"
                    onChange={(e) => setSubscriptionType(e.target.value)}
                    value={subscriptionType}
                  >
                    {availableSubscriptionTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                    ))}
                  </AvField>
                </FormGroup>
              </Col>
              <Col lg="6">
              <FormGroup>
                  <Label for="resourceGroup">Account Resource Group</Label>
                    <AvField
                      type="select"
                      name="resourceGroup"
                      id="resourceGroup"
                      onChange={(e) => setResourceGroup(e.target.value)}
                      value={resourceGroup}
                    >
                      {resourceGroups?.map(resourceGroup => (
                        <option key={resourceGroup.resourcename} value={resourceGroup.resourcename}>{resourceGroup.resourcename}</option>
                      ))}
                    </AvField>
                </FormGroup>
              </Col>

              {/* <Col lg="6">
                <FormGroup>
                  <Label for="location">Location</Label>
                  <AvField
                    name="location"
                    id="location"
                    onChange={(e) => setLocation(e.target.value)}
                    value={location}
                    errorMessage="Enter Location"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col> */}
            </Row>

            <Row>
              <Col lg="12">
                <FormGroup>
                  <Label for="address">Address</Label>
                  <AvField
                    name="address"
                    id="address"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    errorMessage="Enter Address"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="city">City</Label>
                  <AvField
                    name="city"
                    id="city"
                    onChange={(e) => setCity(e.target.value)}
                    value={city}
                    errorMessage="Enter City"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="state">State</Label>
                  <AvField
                    name="state"
                    id="state"
                    onChange={(e) => setState(e.target.value)}
                    value={state}
                    errorMessage="Enter State"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="zip">Zip</Label>
                  <AvField
                    name="zip"
                    id="zip"
                    onChange={(e) => setZip(e.target.value)}
                    value={zip}
                    errorMessage="Enter Zip Code"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="country">Country</Label>
                  <AvField
                    type="select"
                    name="country"
                    id="country"
                    onChange={(e) => setCountry(e.target.value)}  
                    value={country}
                    errorMessage="Select city"
                    validate={{
                      required: {value: true},
                    }}
                  >
                    {countryList.map((country) => {
                      return (
                        <option key={country.code} value={country.name}>
                          {country.name}
                        </option>
                      );
                    })}
                  </AvField>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="email">Email</Label>
                  <AvField
                    name="email"
                    type="email"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    errorMessage="Enter Valid Email"
                    validate={{
                      required: {value: true},
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="phonenumber">Phonenumber</Label>
                  <PhoneInput
                    className={!phoneError? "phone-input": "phone-input invalid"}
                    id="phonenumber"
                    name="phone"
                    aria-describedby="Phone Number"
                    placeholder="Phone Number"
                    value={phonenumber}
                    maxLength={16}
                    onChange={handlePhoneChange}
                    onBlur={handlePhoneBlur}
                    required
                  />
                  {phoneError ? (
                      <div className="text-danger" style={{fontSize: "80%", marginTop: "0.25rem", marginLeft: "1rem"}}>{phoneError}</div>
                  ) : null}
                  </FormGroup>
              </Col>
            </Row>

            <Button
              color="primary"
              variant="contained"
              disabled={isAddOrgAccountFormInvalid() || props.isAddingOrgAccount}
              onClick={handleAddOrgAccount}
            >
              Add Organization Account
            </Button>
          </div>
        </AvForm>
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { isAddingOrgAccount, addOrgAccountError } = state.orgAccount;
  const { isGettingLicense } = state.globalLicense;
  const { isGettingCustomLicense } = state.customLicense;
  return {
    isAddingOrgAccount,
    addOrgAccountError,
    isGettingLicense,
    isGettingCustomLicense,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addOrgAccount: (orgAccountCode, subscription) => {
      dispatch(addOrgAccount(orgAccountCode, subscription));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganizationAccount);
